import React, { useState, useEffect } from "react";
import ImageCard from "./ImageCard";
import GenerationDetails from "./GenerationDetails";
import SourceImageCard from "./SourceImageCard";

function Generation({ generation, setPrompt, onImageDetails }) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Toggle prompt expansion
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const getCharLimit = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 576) return 20; // Small screens
    if (screenWidth <= 1080) return 50; // Medium screens
    return 40; // Large screens
  };

  const promptStyle = {
    flex: 1,
    margin: "auto",
    textAlign: "left",
    alignItems: "center",
  };
  const generationDivStyle = {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "10px",
  };

  const [charLimit, setCharLimit] = useState(getCharLimit());
  useEffect(() => {
    const handleResize = () => setCharLimit(getCharLimit());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getImageKey = (image, generationId, imgIndex) => {
    if (image?.id) return image.id;
    if (image?._id) return image._id;
    if (image?.url) return image.url;
    return `${generationId || "generation"}-${imgIndex}`;
  };

  const generationId =
    generation?.id ||
    generation?._id ||
    generation?.generationId ||
    generation?.createdAt ||
    "generation";

  const validSourceImages = (generation.sourceImages || []).filter(
    (url) => url && typeof url === "string" && url.trim() !== ""
  );

  return (
    <div className="col-12">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={promptStyle}>
          {setPrompt && ( // Only show the icon if setPrompt is provided
            <span
              onClick={() => setPrompt(generation.prompt)}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                fontSize: "1.3rem",
              }}
              title="Reuse this prompt"
            >
              ⬆️
            </span>
          )}
          {isExpanded || generation.prompt.length <= charLimit
            ? generation.prompt
            : `${generation.prompt.substring(0, charLimit)}... `}
          {generation.prompt.length > charLimit && (
            <span
              onClick={toggleExpand}
              style={{ color: "blue", cursor: "pointer" }}
            >
              {isExpanded ? " [-]" : " [+]"}
            </span>
          )}
        </p>

        <GenerationDetails generation={generation} />
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px", alignItems: "center" }}>
        {generation.ambaramImages?.length > 0 ? (
          generation.ambaramImages.map((image, imgIndex) => (
            <ImageCard
              image={image}
              imgIndex={imgIndex}
              key={getImageKey(image, generationId, imgIndex)}
              onDetails={(img) =>
                onImageDetails && onImageDetails(img, generation.prompt)
              }
            />
          ))
        ) : (
          <p>Submit a prompt to create images!</p>
        )}
        {validSourceImages.map((url, idx) => (
          <SourceImageCard key={`source-${idx}`} url={url} />
        ))}
      </div>
    </div>
  );
}

export default Generation;